import { ToggleButtonGroup, ToggleButton, Box, Typography } from '@mui/material'
import { IButtonsGroup } from './types'
import { ReactComponent as ListIcon } from '../../assets/images/listIcon.svg'
import { ReactComponent as TilesIcon } from '../../assets/images/tilesIcon.svg'

const buttonStyle = { display: 'flex', gap: '1rem', alignItems: 'center' }

const ButtonsGroup: React.FC<IButtonsGroup> = ({
  firstButtonLabel,
  secondButtonLabel,
  firstButtonClickHandler,
  secondButtonClickHandler,
  selectedValue,
}) => {
  return (
    <ToggleButtonGroup value={selectedValue} sx={{ height: '36px' }}>
      <ToggleButton
        value='box'
        onClick={firstButtonClickHandler}
        sx={{
          '&.Mui-selected': {
            borderTopRightRadius: '4px !important',
            borderBottomRightRadius: '4px !important',
          },
        }}
      >
        <Box sx={[buttonStyle]}>
          <TilesIcon />
          <Typography variant='bodyBold'>{firstButtonLabel}</Typography>
        </Box>
      </ToggleButton>
      <ToggleButton
        value='list'
        onClick={secondButtonClickHandler}
        sx={{
          '&.Mui-selected': {
            borderTopLeftRadius: '4px !important',
            borderBottomLeftRadius: '4px !important',
          },
        }}
      >
        <Box sx={[buttonStyle]}>
          <ListIcon />
          <Typography variant='bodyBold'>{secondButtonLabel}</Typography>
        </Box>
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default ButtonsGroup
